import React from 'react'

const ConnAdminPanel = () => {
    return (
        <div>ConnAdminPanel</div>
    )
}

export default ConnAdminPanel